<template>
  <div class="row mb-5">
    <div class="col-6 col-md-4 col-lg-3 mb-3 animate__animated animate__fadeIn" v-for="(gradient, index) in gradients"
         v-bind:key="index + 'gradient-card'">

      <div class="card card-outline w-elevation card-gradient">
        <router-link :to="'/gradients/' + gradient.id">
          <div class="card-header text-center py-1 mt-3">
            <p class="subtitle-1 text-uppercase text-truncate mb-0" v-if="gradient.name === null">No name</p>
            <p class="subtitle-1 text-uppercase text-truncate mb-0" v-else>{{ gradient.name }}</p>
          </div>
          <div class="card-body my-0">
            <div class="gradient" v-if="gradient.color3"
                 :style="{ 'background': 'linear-gradient' + '(to right,' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }"></div>
            <div class="gradient" v-else
                 :style="{ 'background': 'linear-gradient' + '(to right,' + gradient.color1 + ',' + gradient.color2 + ')' }"></div>

            <div class="gradient-colors-container d-flex flex-wrap justify-content-between">
              <i class="material-icons" :style="{'color': gradient.color1}">&#xef4a;</i>
              <i class="material-icons" :style="{'color': gradient.color2}">&#xef4a;</i>
              <i v-if="gradient.color3" class="material-icons" :style="{'color': gradient.color3}">&#xef4a;</i>
            </div>
          </div>
        </router-link>
        <div class="card-footer" :class="isDisplay" v-if="user.loggedIn">
          <button :disabled="isLoading" class="btn btn-like ripple" @click="onLikeGradient(gradient)">
            <i :class="[gradient.isLiked ? 'material-icons liked mdc-18': 'material-icons-outlined mdc-18']">&#xe87d;</i>
          </button>
        </div>
        <div class="card-footer" v-else>
          <router-link to="/sign-up" class="btn btn-like ripple">
            <i class="material-icons-outlined mdc-18">&#xe87d;</i>
          </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import {mapGetters} from "vuex";

export default {
  name: 'GradientsList',
  props: [
    'gradients',
    'isDisplay'
  ],
  components: {},
  computed: {
    ...mapGetters(['user'])
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    async onLikeGradient(gradient) {
      const db = firebase.firestore()
      const gradientsLikesRef = db.collection('users').doc(this.user.data.uid).collection('likedGradients').doc(gradient.id)

      this.isLoading = true

      if (gradient.isLiked) {
        await gradientsLikesRef.delete()
      } else {
        let color3 = gradient.color3
        if (color3) {
          await gradientsLikesRef.set({
            name: gradient.name,
            color1: gradient.color1,
            color2: gradient.color2,
            color3: gradient.color3,
            createdAt: new Date(Date.now()).toLocaleString()
          })
        } else {
          await gradientsLikesRef.set({
            name: gradient.name,
            color1: gradient.color1,
            color2: gradient.color2,
            createdAt: new Date(Date.now()).toLocaleString()
          })
        }
      }

      gradient.isLiked = !gradient.isLiked
      this.isLoading = false

      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Liked gradient',
      })
    }
  }
}
</script>